module.exports = __webpack_public_path__ + "img/789-5f727b.png";